import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle } from "lucide-react";
import { useQuestionnaireContext } from "../../context/QuestionnaireContext";
import { PATH_ROOT } from "@/constants";

export function QuestionnaireFinalStep() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAccepted, questionnaireQuery } = useQuestionnaireContext();
  const isStatementsConfirmation =
    isAccepted &&
    questionnaireQuery.data?.questionnaire?.agreement_status ===
      "agreement_amend_statements";

  const { Icon, iconClass, titleClass, title } = useMemo(
    () =>
      isAccepted
        ? {
            Icon: CheckCircle,
            iconClass: "text-green-500",
            titleClass: "text-green-700",
            title: isStatementsConfirmation
              ? t("questionnaires.final.statementsConfirmed")
              : t("questionnaires.final.accepted.title"),
          }
        : {
            Icon: XCircle,
            iconClass: "text-red-500",
            titleClass: "text-red-700",
            title: t("questionnaires.final.rejected.title"),
          },
    [isAccepted, isStatementsConfirmation, t, navigate],
  );

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="text-center">
            <Icon className={`h-16 w-16 mx-auto mb-4 ${iconClass}`} />
            <h2 className={`text-2xl font-bold mb-6 ${titleClass}`}>{title}</h2>
            <Button onClick={() => navigate(PATH_ROOT)} className="w-full">
              {t("questionnaires.final.loginAction")}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
